import request from '@/CommonDP/utils/request';
// 系统设置
export default {
  accelerationServerAdd(params) {
    return request
      .post('/enterprise/accelerationServer/add', params)
      .then((res) => res);
  },
  accelerationServerList(enterpriseId, keyword) {
    return request
      .get(
        '/enterprise/accelerationServer/list?enterpriseId=' +
          enterpriseId +
          '&keyword=' +
          keyword
      )
      .then((res) => res);
  },
  accelerationServerUpdate(params) {
    return request
      .post('/enterprise/accelerationServer/update', params)
      .then((res) => res);
  },
  getDates(params) {
    return request(
      `/workday/list?yearTime=${params.yearTime}&monthTime=${params.monthTime}`
    ).then((res) => res);
  },
  updateDates(params) {
    return request.post('/workday/update', params).then((res) => res);
  },

  queryTreeOrginfo() {
    return request
      .get(`/worktimeStatistics/newOrgInfo?type=children`)
      .then((res) => res);
  },

  autoReportDetail(userId) {
    return request
      .get(`/workOperateRealTime/list?userId=${userId}`)
      .then((res) => res);
  },

  getSystemOnlineNum(params) {
    return request.get(`/onlineUser/count`).then((res) => res);
  },

  getSystemOnlineList(params) {
    return request
      .get(`/onlineUser/infoList`, { data: params })
      .then((res) => res);
  },

  areaList(enterpriseId) {
    return request
      .get(`/project/provinceCity/List?enterpriseId=${enterpriseId}`)
      .then((res) => res);
  },

  getPrjList(enterpriseId) {
    return request
      .get(`/project/prj/List?enterpriseId=${enterpriseId}`)
      .then((res) => res);
  },

  queryUserNoSubmitDate: (params) =>
    request('/worktimeStatistics/queryUserNoSubmitDate', {
      params
    }).then((res) => res),

  getDepartProjectsData() {
    return request.get('/project/approval-list').then((res) => res);
  },

  // 统计模块新接口
  getStatisticalHoursDataNew(params, pageNo, pageSize) {
    return request
      .post(
        '/worktimeStatistics/everybody/workTime?pageNum=' +
          pageNo +
          '&pageSize=' +
          pageSize,
        params
      )
      .then((res) => res);
  },

  getPrjWorkTimeData(params) {
    return request
      .post('/count/prj-worktime', params)
      .then((res) => res)
      .catch(function(reason) {
        console.log('catch:', reason);
      });
  },

  getPrjUserData(params) {
    return request
      .post(
        '/count/project-user-num?pageNo=' + 1 + '&pageSize=' + 70,
        params
      )
      .then((res) => res)
      .catch(function(reason) {
        console.log('catch:', reason);
      });
  },

  getUserWorkTimeData(params) {
    return request
      .post('/count/prj-working-people-number', params)
      .then((res) => res)
      .catch(function(reason) {
        console.log('catch:', reason);
      });
  },

  getPrjUsers(params) {
    return request.post('/user/list-staff', params).then((res) => res);
  },

  countDetail(params) {
    return request
      .post('/worktime/currentUser/list', params)
      .then((res) => res);
  },

  accelerationServerDelete(serverId) {
    return request
      .get('/enterprise/accelerationServer/delete?serverId=' + serverId)
      .then((res) => res);
  },
  accelerationServerbatchDelete(params) {
    return request
      .post('/enterprise/accelerationServer/batchDelete', params)
      .then((res) => res);
  }
};
